import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { clearNotice } from './actions';
import { NOTICE_SECONDS } from './constants';
import { selectNotice } from './reducer';
import { Banner, Close, Open } from './styled';

/** The latest game notice while the app is open (Notices sagas): tap it to open the game. */
const Notices = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const notice = useSelector(selectNotice);

  useEffect(() => {
    if (!notice) {
      return undefined;
    }
    const timer = setTimeout(() => dispatch(clearNotice()), NOTICE_SECONDS * 1000);
    return () => clearTimeout(timer);
  }, [notice, dispatch]);

  if (!notice) {
    return null;
  }

  const open = () => {
    dispatch(clearNotice());
    navigate(notice.url);
  };

  return (
    <Banner role="status">
      <Open type="button" onClick={open}>
        <img src="/icon-192.png?v=2" alt="" />
        <div>
          <strong>{notice.title}</strong>
          <span>{notice.body}</span>
        </div>
      </Open>
      <Close type="button" aria-label="Dismiss" onClick={() => dispatch(clearNotice())}>×</Close>
    </Banner>
  );
};

export default Notices;
